import Image from "next/image";
import Link from "next/link";
import React from "react";

import { MerchandisingItem } from "@/graphql/types/graphql";
import { Search_Type } from "@/graphql/types/graphql";
import { encodeURL } from "@/utils/index";

interface MobileCarouselProps {
  items: MerchandisingItem[];
  numberPerSlide?: number;
  handleItemClick: (item: MerchandisingItem) => void;
  isEdits?: boolean;
  searchType?: Search_Type;
}

const MobileCarousel: React.FC<MobileCarouselProps> = ({
  items = [],
  numberPerSlide = 4,
  handleItemClick,
  isEdits = true,
  searchType,
}) => {
  const isSearch = numberPerSlide === 4;
  const itemWidth = isSearch ? 173 : 126;
  const itemTitleStyle = isSearch
    ? {
        marginTop: 24,
        fontWeight: 500,
      }
    : {
        marginTop: 16,
        fontWeight: 700,
      };

  return (
    <>
      <div className="mobile-carousel-wrapper">
        <ul className="mobile-carousel">
          {items.map((item) => (
            <Link
              key={item.text}
              href={
                !item.brandID
                  ? `/${isEdits ? "edits" : "results"}/${encodeURL(
                      item.searchQuery || ""
                    )}${
                      searchType === Search_Type.Item
                        ? `?type=${searchType}`
                        : ""
                    }`
                  : `/brand/${encodeURL(item.text)}/${item.brandID}`
              }
              onClick={() => handleItemClick(item)}
            >
              <li className="mobile-carousel-item" style={{ width: itemWidth }}>
                <div className="item-image-cover">
                  <Image
                    src={item.image}
                    alt={item.text}
                    loading="lazy"
                    width={173}
                    height={247.14}
                    style={{
                      objectFit: "cover",
                      objectPosition: "center bottom",
                      aspectRatio: 0.7,
                    }}
                  />
                </div>
                <span className="item-text" style={itemTitleStyle}>
                  {item.text}
                </span>
              </li>
            </Link>
          ))}
        </ul>
      </div>
      <style jsx>{`
        .mobile-carousel-wrapper {
          width: 100%;
          overflow-x: auto;
          -ms-overflow-style: none;
          scrollbar-width: none;
          &::-webkit-scrollbar {
            display: none; /* for Chrome, Safari, and Opera */
          }

          .mobile-carousel {
            width: fit-content;
            display: flex;
            align-items: stretch;

            .mobile-carousel-item {
              margin-right: 16px;

              .item-image-cover {
                width: 100%;
                overflow: hidden;
              }
              .item-text {
                color: #191919;
                text-align: left;
                font-size: 16px;
                font-weight: 500;
                margin-top: 24px;
                display: block;
                line-height: normal;
                letter-spacing: -0.32px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 4;
                -webkit-box-orient: vertical;
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                font-smooth: never;
              }
            }
          }
        }
      `}</style>
    </>
  );
};

export default MobileCarousel;
